import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiMapPin, FiClock, FiUsers, FiAward, FiBookOpen, FiHome, FiPhone, FiMail, FiInfo } from "react-icons/fi";

class AboutMuseum extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='เกี่ยวกับเรา' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor1/IMG_7801.webp")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '60vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 className="hero-title" style={{
                                    color: 'white',
                                    fontSize: '3.5rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                }}>
                                    เกี่ยวกับพิพิธภัณฑ์สิงห์ท่า
                                </h1>
                                <p className="hero-subtitle" style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    opacity: 0.9,
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
                                }}>
                                    ศูนย์เรียนรู้ประวัติศาสตร์และวิถีชีวิตชุมชนเมืองเก่าบ้านสิงห์ท่า
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Introduction Section */}
                <div className="intro-section ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="intro-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor1/IMG_7829.webp" alt="พิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="intro-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        เกี่ยวกับพิพิธภัณฑ์สิงห์ท่า
                                    </h2>
                                    <p className="description" style={{
                                        color: '#666',
                                        lineHeight: '1.8',
                                        fontSize: '1.5rem',
                                        marginBottom: '2rem'
                                    }}>
                                        พิพิธภัณฑ์สิงห์ท่าก่อตั้งขึ้นเพื่อรวบรวมและเผยแพร่เรื่องราวของชุมชนสิงห์ท่า จัดแสดงนิทรรศการทางประวัติศาสตร์และวิถีชีวิตพื้นถิ่น พร้อมกิจกรรมให้ความรู้แก่ผู้เยี่ยมชมตลอดปี
                                    </p>
                                    <div className="intro-stats" style={{
                                        display: 'flex',
                                        gap: '2rem',
                                        flexWrap: 'wrap'
                                    }}>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                200+
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                ปี ประวัติศาสตร์
                                            </div>
                                        </div>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                2
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                ชั้น นิทรรศการ
                                            </div>
                                        </div>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                9
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                ส่วนจัดแสดง
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                           <div className="features-section ptb--50" style={{ backgroundColor: 'white' }}>
                                    <div className="container">
                                        <div className="row justify-content-center">
                                            <div className="col-lg-10">
                                                <div className="section-title text-center mb-5">
                                                    <h2 className="title" style={{
                                                        fontSize: '2.5rem',
                                                        fontWeight: 'bold',
                                                        color: '#242424',
                                                        marginBottom: '1rem'
                                                    }}>
                                                        จุดเด่นของพิพิธภัณฑ์
                                                    </h2>
                                                </div>
                
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6 mb-4">
                                                        <div className="feature-card" style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '2rem',
                                                            borderRadius: '15px',
                                                            textAlign: 'center',
                                                            height: '100%',
                                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                            cursor: 'pointer'
                                                        }} onMouseEnter={(e) => {
                                                            e.target.style.transform = 'translateY(-10px)';
                                                            e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                                        }} onMouseLeave={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = 'none';
                                                        }}>
                                                            <div className="feature-icon" style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: '80px',
                                                                height: '80px',
                                                                backgroundColor: '#F45354',
                                                                borderRadius: '50%',
                                                                marginBottom: '1.5rem'
                                                            }}>
                                                                <FiMapPin style={{ color: 'white', fontSize: '2rem' }} />
                                                            </div>
                                                            <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1rem', color: '#242424' }}>
                                                                ตำแหน่งที่ตั้ง
                                                            </h3>
                                                            <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                                ตั้งอยู่ตรงข้ามศาลเจ้าพ่อหลักเมือง ใจกลางเมืองเก่าบ้านสิงห์ท่า
                                                            </p>
                                                        </div>
                                                    </div>
                
                                                    <div className="col-lg-4 col-md-6 mb-4">
                                                        <div className="feature-card" style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '2rem',
                                                            borderRadius: '15px',
                                                            textAlign: 'center',
                                                            height: '100%',
                                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                            cursor: 'pointer'
                                                        }} onMouseEnter={(e) => {
                                                            e.target.style.transform = 'translateY(-10px)';
                                                            e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                                        }} onMouseLeave={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = 'none';
                                                        }}>
                                                            <div className="feature-icon" style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: '80px',
                                                                height: '80px',
                                                                backgroundColor: '#F45354',
                                                                borderRadius: '50%',
                                                                marginBottom: '1.5rem'
                                                            }}>
                                                                <FiAward style={{ color: 'white', fontSize: '2rem' }} />
                                                            </div>
                                                            <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1rem', color: '#242424' }}>
                                                                สถาปัตยกรรม
                                                            </h3>
                                                            <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                                ออกแบบในรูปแบบโคโลเนี่ยลที่สอดคล้องกับประวัติศาสตร์ของพื้นที่
                                                            </p>
                                                        </div>
                                                    </div>
                
                                                    <div className="col-lg-4 col-md-6 mb-4">
                                                        <div className="feature-card" style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '2rem',
                                                            borderRadius: '15px',
                                                            textAlign: 'center',
                                                            height: '100%',
                                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                                            cursor: 'pointer'
                                                        }} onMouseEnter={(e) => {
                                                            e.target.style.transform = 'translateY(-10px)';
                                                            e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                                                        }} onMouseLeave={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = 'none';
                                                        }}>
                                                            <div className="feature-icon" style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: '80px',
                                                                height: '80px',
                                                                backgroundColor: '#F45354',
                                                                borderRadius: '50%',
                                                                marginBottom: '1.5rem'
                                                            }}>
                                                                <FiBookOpen style={{ color: 'white', fontSize: '2rem' }} />
                                                            </div>
                                                            <h3 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1rem', color: '#242424' }}>
                                                                นิทรรศการ
                                                            </h3>
                                                            <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                                นำเสนอประวัติศาสตร์ผ่านการค้าขายและร้านค้าในรูปแบบ Shophouse
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                {/* Contact Section */}
                {/* <div className="contact-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="section-header text-center mb-5">
                                    <h2 className="title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        ติดต่อเรา
                                    </h2>
                                </div>
                                <div className="contact-content" style={{
                                    backgroundColor: 'white',
                                    padding: '3rem',
                                    borderRadius: '20px',
                                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 mb-4">
                                            <div className="contact-item" style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                marginBottom: '2rem'
                                            }}>
                                                <div className="contact-icon" style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '50px',
                                                    height: '50px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginRight: '1rem',
                                                    flexShrink: 0
                                                }}>
                                                    <FiMapPin style={{ color: 'white', fontSize: '1.2rem' }} />
                                                </div>
                                                <div className="contact-info">
                                                    <h4 style={{
                                                        fontSize: '1.2rem',
                                                        fontWeight: 'bold',
                                                        color: '#242424',
                                                        marginBottom: '0.5rem'
                                                    }}>
                                                        สถานที่ตั้ง
                                                    </h4>
                                                    <p style={{
                                                        color: '#666',
                                                        lineHeight: '1.6',
                                                        margin: 0
                                                    }}>
                                                        สิงห์ท่ามิวเซียม<br />
                                                        อาคารพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่า<br />
                                                        ถนนอุทัยรามฤทธิ์ ตำบลในเมือง<br />
                                                        อำเภอเมือง จังหวัดยโสธร 35000
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 mb-4">
                                            <div className="contact-item" style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                marginBottom: '2rem'
                                            }}>
                                                <div className="contact-icon" style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '50px',
                                                    height: '50px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginRight: '1rem',
                                                    flexShrink: 0
                                                }}>
                                                    <FiPhone style={{ color: 'white', fontSize: '1.2rem' }} />
                                                </div>
                                                <div className="contact-info">
                                                    <h4 style={{
                                                        fontSize: '1.2rem',
                                                        fontWeight: 'bold',
                                                        color: '#242424',
                                                        marginBottom: '0.5rem'
                                                    }}>
                                                        ติดต่อประสานงาน
                                                    </h4>
                                                    <p style={{
                                                        color: '#666',
                                                        lineHeight: '1.6',
                                                        margin: 0
                                                    }}>
                                                        กองการศึกษา เทศบาลเมืองยโสธร<br />
                                                        เลขที่ 1 ถนนประชาสัมพันธ์<br />
                                                        ตำบลในเมือง อำเภอเมืองยโสธร<br />
                                                        จังหวัดยโสธร 35000<br />
                                                        โทรศัพท์ 045 712252
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Visiting Information Section */}
                <div className="visiting-section ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="section-header text-center mb-5">
                                    <h2 className="title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        การเข้าชม
                                    </h2>
                                </div>

                                {/* Opening Hours */}
                                <div className="info-card mb-5" style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '2rem',
                                    borderRadius: '15px',
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="card-header" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '1.5rem'
                                    }}>
                                        <div className="header-icon" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '50px',
                                            height: '50px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            marginRight: '1rem'
                                        }}>
                                            <FiClock style={{ color: 'white', fontSize: '1.2rem' }} />
                                        </div>
                                        <h3 style={{
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                            color: '#242424',
                                            margin: 0
                                        }}>
                                            เวลาและการให้บริการ
                                        </h3>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table" style={{
                                            backgroundColor: 'white',
                                            borderRadius: '10px',
                                            overflow: 'hidden'
                                        }}>
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424',
                                                        width: '40%'
                                                    }}>
                                                        วันอังคาร - วันศุกร์
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#666' }}>
                                                        9.00 – 16.00 น.
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424'
                                                    }}>
                                                        วันเสาร์ - วันอาทิตย์
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#666' }}>
                                                        9.30 – 16.30 น.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th colSpan="2" style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#F45354',
                                                        color: 'white',
                                                        textAlign: 'center',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        หยุดวันจันทร์
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Admission Fees */}
                                <div className="info-card mb-5" style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '2rem',
                                    borderRadius: '15px',
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="card-header" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '1.5rem'
                                    }}>
                                        <div className="header-icon" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '50px',
                                            height: '50px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            marginRight: '1rem'
                                        }}>
                                            <FiUsers style={{ color: 'white', fontSize: '1.2rem' }} />
                                        </div>
                                        <h3 style={{
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                            color: '#242424',
                                            margin: 0
                                        }}>
                                            อัตราค่าบริการ
                                        </h3>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table" style={{
                                            backgroundColor: 'white',
                                            borderRadius: '10px',
                                            overflow: 'hidden'
                                        }}>
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424',
                                                        width: '60%'
                                                    }}>
                                                        ชาวไทย
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#666' }}>
                                                        20 บาท
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424'
                                                    }}>
                                                        ชาวต่างชาติ
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#666' }}>
                                                        40 บาท
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424'
                                                    }}>
                                                        ผู้พิการ
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#28a745', fontWeight: 'bold' }}>
                                                        ฟรี
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424'
                                                    }}>
                                                        ภิกษุ สามเณร และนักบวชในศาสนาอื่น
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#28a745', fontWeight: 'bold' }}>
                                                        ฟรี
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424'
                                                    }}>
                                                        เด็กที่มีส่วนสูงต่ำกว่า 100 เซนติเมตร
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#28a745', fontWeight: 'bold' }}>
                                                        ฟรี
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424'
                                                    }}>
                                                        นักเรียน นักศึกษา (แสดงบัตร)
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#28a745', fontWeight: 'bold' }}>
                                                        ฟรี
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424'
                                                    }}>
                                                        ผู้ที่อายุเกิน 60 ปีขึ้นไป (แสดงบัตร)
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#28a745', fontWeight: 'bold' }}>
                                                        ฟรี
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Group Visits */}
                                <div className="info-card mb-5" style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '2rem',
                                    borderRadius: '15px',
                                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                                }}>
                                    <div className="card-header" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '1.5rem'
                                    }}>
                                        <div className="header-icon" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '50px',
                                            height: '50px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            marginRight: '1rem'
                                        }}>
                                            <FiUsers style={{ color: 'white', fontSize: '1.2rem' }} />
                                        </div>
                                        <h3 style={{
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                            color: '#242424',
                                            margin: 0
                                        }}>
                                            การเข้าชมเป็นหมู่คณะ*
                                        </h3>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table" style={{
                                            backgroundColor: 'white',
                                            borderRadius: '10px',
                                            overflow: 'hidden'
                                        }}>
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #eee' }}>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424',
                                                        width: '60%'
                                                    }}>
                                                        ส่วนราชการ หน่วยงาน องค์กรต่างๆ
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#ffc107', fontWeight: 'bold' }}>
                                                        ส่วนลด 50%
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th style={{
                                                        padding: '1rem',
                                                        backgroundColor: '#f8f9fa',
                                                        fontWeight: 'bold',
                                                        color: '#242424'
                                                    }}>
                                                        สถานศึกษาหรือสถาบันการศึกษา
                                                    </th>
                                                    <td style={{ padding: '1rem', color: '#28a745', fontWeight: 'bold' }}>
                                                        ฟรี
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                      <div className="card-header" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '1.5rem'
                                    }}>
                                        <h6 style={{
                                            fontSize: '0.4 rem',
                                            color: '#242424',
                                            margin: 0
                                        }}>
                                          *กรุณาติดต่อ ประสานงาน กองการศึกษา เทศบาลเมืองยโสธร ล่วงหน้าอย่างน้อย 15 วัน
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Rules Section */}
                <div className="rules-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="section-header text-center mb-5">
                                    <h2 className="title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        ข้อปฏิบัติในการเข้าชมสิงห์ท่ามิวเซียม
                                    </h2>
                                </div>
                                <div className="rules-content" style={{
                                    backgroundColor: 'white',
                                    padding: '3rem',
                                    borderRadius: '20px',
                                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)'
                                }}>
                                    <ol style={{
                                        color: '#666',
                                        lineHeight: '1.8',
                                        fontSize: '1.5rem',
                                        paddingLeft: '1.5rem'
                                    }}>
                                        <li style={{ marginBottom: '1rem' }}>
                                            ไม่นำอาวุธ วัตถุระเบิด วัตถุเชื้อเพลิง หรือสารเคมีอันจะก่อให้เกิดอันตรายเข้าไปในอาคาร
                                        </li>
                                        <li style={{ marginBottom: '1rem' }}>
                                            ไม่จับต้องหรือหยิบฉวยหรือกระทำการใดๆ อันอาจเป็นเหตุให้เกิดความชำรุดหรือเสียหายแก่สิ่งของที่จัดตั้งแสดง
                                        </li>
                                        <li style={{ marginBottom: '1rem' }}>
                                            ไม่ขีด เขียน หรือทำให้ปรากฏด้วยประการใดๆ ซึ่งข้อความ ภาพหรือรูปรอยใดๆบนวัตถุจัดแสดงและพื้นผิวอาคาร
                                        </li>
                                        <li style={{ marginBottom: '1rem' }}>
                                            ไม่สูบบุหรี่ภายในอาคาร
                                        </li>
                                        <li style={{ marginBottom: '1rem' }}>
                                            ไม่กระทำการใดๆ อันอาจเป็นเหตุให้เกิดความชำรุด เสียหาย หรือก่อให้เกิดความสกปรก และไม่เป็นระเบียบเรียบร้อย
                                        </li>
                                        <li style={{ marginBottom: '1rem' }}>
                                            ไม่นำสัตว์เลี้ยงทุกชนิดเข้าไปในอาคาร
                                        </li>
                                        <li style={{ marginBottom: '1rem' }}>
                                            ไม่นำอาหารหรือเครื่องดื่มเข้าไปในอาคาร
                                        </li>
                                        <li style={{ marginBottom: '1rem' }}>
                                            อนุญาตให้ถ่ายภาพหรือบันทึกอื่นๆ เว้นแต่การถ่ายภาพหรือบันทึกอื่นๆ เพื่อมุ่งประโยชน์ด้านการค้า
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>

                <Footer />
            </React.Fragment>
        )
    }
}

export default AboutMuseum;
